module.exports = __webpack_public_path__ + "static/media/400042_02.ce01d997.png";